export default class GenericBoostModal {
    // Handlers are valid getElementByQuery
    // $ are jquery objects
    // classes are strings (not handlers)
    // JavaScript animation is like putting ketchup on ice cream. IT'S SO WRONG
    // parentToItemToClick is needed so we get a high enough parent that intercooler doesn't screw us
    constructor(
        parentToItemToClick,
        clickThisToTurnMeOn,
        modalHandler,
        closeModalHandler,
        modalActiveClass = "agent-promo-edit-campaign-modal--active",
        modalBackgroundClass = "agent-promo-edit-campaign-modal__bg",
        callbackOnOpen = null,
        turnOffParentBeforeAddingEvent = true
    ) {
        // Save reference to this object for within jQuery callbacks
        let self = this;

        // needed for intercooler
        this.parentSelector = parentToItemToClick;
        this.clickableItemSelector = clickThisToTurnMeOn;

        // Modal
        this.modalHandler = modalHandler;
        this.$modal = jQuery(this.modalHandler);
        this.modalActiveClass = modalActiveClass;

        // Close
        this.closeModalHandler = closeModalHandler;
        this.$closeModalButton = jQuery(this.closeModalHandler);
        this.ignoreCloseRequests = false;

        // Close modal on click
        this.$closeModalButton.click(this.close.bind(this));

        // Background of modal
        this.modalBackgroundClass = modalBackgroundClass;
        this.modalBackgroundHandler = "." + this.modalBackgroundClass;

        this.callback = callbackOnOpen;

        // close modal on click of bg
        jQuery(this.modalBackgroundHandler).click((event) => {
            if (event.target.className === self.modalBackgroundClass) {
                self.close(event);
            }
        });

        // Close modal on ESC
        jQuery(document).on("keydown", (event) => {
            if (event.key === "Escape") {
                self.close(event);
            }
        });

        // When the user clicks on the thing that was passed in, open the goshdarn modal
        const parent = jQuery(this.parentSelector);
        if (turnOffParentBeforeAddingEvent) {
            parent.off();
        }
        parent.on("click", this.clickableItemSelector, this.open.bind(this));
    }

    stopListeningForClicks() {
        const parent = jQuery(this.parentSelector);
        parent.off("click");
    }

    open(event) {
        if (typeof event !== "undefined") {
            // Prevent anchor tag jump on click
            event.preventDefault();
        }

        if (
            jQuery(this.clickableItemSelector).attr("disabled") === "disabled"
        ) {
            return;
        }

        // Add active class (show the darn thing)
        this.$modal.addClass(this.modalActiveClass);

        if (this.callback) {
            this.callback();
        }

        // prevent background from scrolling
        jQuery("body").css("overflow", "hidden");

        if (this.$modal.find(".input--js").length) {
            this.$modal.find(".input--js").first().focus();
        } else {
            // Focus on our first focus-able element (this is really naive and implies that all focus-able elements in this modal are a tags)
            this.$modal.find("a").first().focus();
        }
    }

    openIfExists(event) {
        if (this.$modal.length) {
            this.open(event);
        }
    }

    close(event) {
        if (this.ignoreCloseRequests) {
            // needed for "final" modals in flows where we have to reload the page or wait for an async call
            return;
        }

        // to prevent anchor tag to jump to top of page when being clicked on, if JS event was passed into this function (otherwise throws error)
        if (typeof event !== "undefined") {
            // Prevent anchor tag jump
            event.preventDefault();
        }

        // Remove active class (hide the dang thing)
        this.$modal.removeClass(this.modalActiveClass);

        // Allow scrolling again
        jQuery("body").css("overflow", "inherit");
    }
}
